import colors from 'vuetify/es5/util/colors';
import InventoryIcon from '~/components/SvgIcons/InventoryIcon.vue';
import GamesIcon from '~/components/SvgIcons/GamesIcon.vue';
import ShareIcon from '~/components/SvgIcons/ShareIcon.vue';
import SocialIcon from '~/components/SvgIcons/SocialIcon.vue';
import SendIcon from '~/components/SvgIcons/SendIcon.vue';
import ConvertIcon from '~/components/SvgIcons/ConvertIcon.vue';
import NodeIcon from '~/components/SvgIcons/NodeIcon.vue';
import StoreIcon from '~/components/SvgIcons/StoreIcon.vue';

export default {
  icons: {
    iconfont: 'fa',
    values: {
      convert: {
        component: ConvertIcon,
      },
      games: {
        component: GamesIcon,
      },
      inventory: {
        component: InventoryIcon,
      },
      nodes: {
        component: NodeIcon,
      },
      send: {
        component: SendIcon,
      },
      share: {
        component: ShareIcon,
      },
      social: {
        component: SocialIcon,
      },
      store: {
        component: StoreIcon,
      },
    },
  },
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        accent: {
          base: '#161618',
          darken1: '#0A0202',
        },
        accent1: '#011B36',
        accent2: '#161618',
        accent3: '#383A45',
        accentBerry: '#262262',
        accentBlue: '#268AEF',
        accentBlueDark: '#011B36',
        accentBlueLight: '#58afe4',
        accentBlueLightSecondary: '#1483E0',
        accentGold: '#dcb577',
        accentLight: '#c9d6df',
        accentPink: '#FF34A2',
        accentPurple: '#7633FF',
        accentTeal: '#2af1fd',
        accentGray: '#535353',
        accentLightGray: '#727272',
        accentWhiteGray: '#c8c8c8',
        accentDarkGray: '#1c1c1c',
        accentTextLightGray: '#A6A6A6',
        accentWarmDarkGray: '#121212',
        accentWarmLightGray: '#232323',
        anchor: '#ffffff',
        error: colors.deepOrange.accent4,
        modalBackground: {
          base: '#52616b',
          darken1: '#37444D',
          lighten1: '#677680',
          galamodern: '#181818',
        },
        modalGray: {
          base: '#8C9FAC',
          darken1: '#3E4950',
        },
        primary: '#454545',
        secondary: '#2b2b30',
        textColor: '#ffffff',
      },
      light: {
        accent: '#ffffff',
        accent1: '#f0f5f9',
        accent2: '#8fb7dc',
        accent3: '#c9d6df',
        accentBerry: '#262262',
        accentBlue: '#268AEF',
        accentBlueDark: '#011B36',
        accentBlueLight: '#58afe4',
        accentBlueLightSecondary: '#1483E0',
        accentGold: '#dcb577',
        accentLight: '#c9d6df',
        accentTeal: '#2af1fd',
        anchor: '#011B36',
        error: colors.deepOrange.accent4,
        modalBackground: '#52616b',
        modalGray: '#8C9FAC',
        primary: '#ffffff',
        secondary: '#F6F9FB',
        textColor: '#011B36',
      },
    },
  },
};
